import oInfo from "../info.json";

//Multimedia
import MealPrep from "../Multimedia/Images/MealPrep.jpg";

const AboutContainer = () => {
  const { sHeader, sSubHeader, sContent } = oInfo.oAboutPage;
  return (
    <section className="flex-row card" id="about-section">
      <div className="flex-column">
        <img src={MealPrep} alt="Splash" className="card-img" />
      </div>
      <div className="flex-column flex-center card-content-column">
        <h2 className="card-header">{sHeader}</h2>
        <h3 className="card-subheader banner-background">
          <span className="subheader-span">{sSubHeader}</span>
        </h3>
        <p className="card-content">{sContent}</p>
      </div>
    </section>
  );
};

export default AboutContainer;
